<template>
        <div>
                <el-button type="primary"
                        icon="el-icon-plus"
                        size="small"
                        @click="openDialog('add')"
                >新 增</el-button>
                <el-dialog
                        :title="title"
                        width="65%"
                        :bottom="0"
                        top="60px"
                        append-to-body
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"
                        class="planManagement-addForm"
                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFullChange"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
                
                <div :style="'max-height:'+ dialogBodyHight + 'px;overflow:scroll;'">
                        <avue-form ref="form" id="examinetopic-form" 
                                
                                v-model="form" 
                                v-if="dialogVisible"  
                                :option="option" 
                                @reset-change="emptytChange" 
                                >
                                <template slot="contractId">
                                        <el-button size="small"  @click="addConstract" :disabled="viewType" type="primary">
                                                关联合同
                                        </el-button>
                                </template>
                                <template slot="assessStandardDetailList" >
                                        <div>
                                                <avue-crud 
                                                        :option="assessStandardDetailOption"
                                                        :table-loading="loading"
                                                        @row-update="rowUpdate"
                                                        @row-save="rowSave"
                                                        v-model="addObjectForm"
                                                        :data="assessStandardDetailList"
                                                        ref="crud"
                                                        
                                                >
                                                <template slot="menuLeft">
                                                        <assessmentProject v-if="!viewType" ref="assessmentProjectForm" @add="rowSave" @update="rowUpdate"></assessmentProject>
                                                </template>
                                                <template slot="menu" slot-scope="scope">
                                                        <el-button 
                                                                type="text"
                                                                size="small"
                                                                @click="handleEdit(scope.row)">编 辑

                                                        </el-button>
                                                        <el-button 
                                                                type="text"
                                                                size="small"
                                                                @click="rowDel(scope.row)">删 除

                                                        </el-button>
                                                </template>
                                                <template slot-scope="scope" slot="content">
                                                        <wq-overHidden :content="scope.row.content">
                                                                <span>{{scope.row.content}}</span>
                                                        </wq-overHidden>
                                                </template>
                                                <template slot-scope="scope" slot="demand">
                                                        <wq-overHidden :content="scope.row.demand">
                                                                {{scope.row.demand}}
                                                        </wq-overHidden>
                                                </template>
                                                </avue-crud>
                                        </div>
                                </template>
                        </avue-form>
                </div>
                <template slot="footer" v-if="!viewType">
                        <el-divider></el-divider>
                        <div v-loading="loading">
                              <el-button icon="el-icon-circle-plus-outline" @click="submitAssess" size="small" type="primary">{{ title=="新 增"?'保 存':'修 改' }}</el-button>  
                              <el-button icon="el-icon-circle-close" style="margin-right:10px" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                
                </el-dialog>
                
                <choiceContract ref="choiceContract"  :projectId.sync='this.form.projectId'  @getConstract="getContract"></choiceContract>
        </div>
</template>

<script>
import {submitAssess,getDetail} from "@/api/crmedical/examine/examinetopic";
import choiceContract from '@/components/choiceContract/choiceDeviceContractv2';
import assessmentProject from "./examinetopic-form-type.vue"
import { getStore } from '@/util/store';
export default {
        props:['projectId'],
        components:{
                choiceContract,
                assessmentProject
        },
        data(){
                return{
                        assessStandardDetailOption:{
                                tip: false,
                                calcHeight:'auto',
                                border: true,
                                index: true,
                                selection: false,
                                align:"left",
                                columnBtn:false,
                                header:true,
                                addBtn:false,
                                viewBtn:false,
                                editBtn:false,
                                delBtn:false,
                                stripe:true,
                                menu:true,
                                menuWidth:100,
                                column:[
                                        {       
                                                label:"标准内容",
                                                prop:'content',
                                                minWidth:200,
                                                slot:true,
                                                span:24,
                                                type:"textarea",
                                                maxlength:200,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入标准内容",
                                                        trigger: "change"
                                                }]
                                                // overHidden:true,
                                        },
                                        {       
                                                label:"考核要求",
                                                prop:'demand',
                                                minWidth:180,
                                                slot:true,
                                                span:24,
                                                type:"textarea",
                                                maxlength:100,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入考核要求",
                                                        trigger: "change"
                                                }]
                                                // overHidden:true,
                                        },
                                        {       
                                                label:"分值",
                                                prop:'score',
                                                rules:[
                                                        { required: true, message: '请输入 分值', trigger: 'blur' },
                                                        { pattern:/^((0|[1-9]{1}[0-9]{0,1})|100)$/g ,message:'请输入0-100整数', trigger: 'blur' },
                                                ],
                                                minWidth:100,
                                        },
                                        {       
                                                label:"基准分值",
                                                prop:'baseScore',
                                                minWidth:100,
                                                rules:[
                                                        { required: true, message: '请输入 基准分值', trigger: 'blur' },
                                                        { pattern:/^((0|[1-9]{1}[0-9]{0,1})|100)$/g ,message:'请输入0-100整数', trigger: 'blur' },
                                                ],
                                        },
                                       
                                ]
                        },
                        dialogFull:false,
                        viewType:false,
                        dialogBodyHight:0,//弹窗bidy高度
                        addObjectShow:false,//是否展示新增表格表单
                        title:"新增",
                        dialogVisible:false,
                        loading:false,
                        addObject:[],
                        form:{
                                totalScore:0,
                                baseScore:0,
                        },
                        addObjectForm:{},//新增考核项目表单
                        assessStandardDetailList:[],
                        option:{
                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                labelWidth:120,
                                submitBtn:false,
                                column:[
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                type: 'tree',
                                                span:8,
                                                cascaderItem: ['objectType'],
                                                searchClearable:false,
                                                editDisabled:true,
                                                dicData:getStore({name: 'projectList'}),
                                                props: { label: 'name', value: 'id' },
                                                searchPlaceholder:"请选择 项目名称",
                                                rules: [{
                                                required: true,
                                                message: "请选择项目名称",
                                                trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "考核对象",
                                                prop: "objectType",
                                                type: "select",
                                                span:8,
                                                searchPlaceholder:"请选择 考核对象",
                                                dicUrl: "/api/v4ward/projectDict/dictionary?code=project_examine_service_type&projectId={{key}}",
                                                props: {
                                                        label: "dictValue",
                                                        value: "dictKey",
                                                },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择考核对象",
                                                        trigger: "blur"
                                                }]
                                        },
                                        {
                                                label: "状态",
                                                type:"select",
                                                span:8,
                                                value:1,
                                                searchPlaceholder:"请选择 状态",
                                                prop: "status",
                                                disabled:true,
                                                dicData:[{label:'启用',value:1,},{label:'停用',value:0,},],
                                                props:{
                                                        label:"label",
                                                        value:"value"
                                                },
                                        },
                                        {
                                                label: "标准名称",
                                                span: 24,
                                                prop: "name",
                                                showWordLimit:true,
                                                maxlength:50,
                                                searchPlaceholder:"请输入 标准名称",
                                                rules: [{
                                                        required: true,
                                                        message: "请输入 标准名称",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "关联合同",
                                                disabled:true,
                                                span: 8,
                                                formslot:true,
                                                prop: "contractId",
                                                searchPlaceholder:"请输入 关联合同",
                                        },
                                        {
                                                label: "合同名称",
                                                span: 8,
                                                disabled:true,
                                                prop: "contractName",
                                                searchPlaceholder:"请输入 合同名称",
                                        },
                                        {
                                                label: "合同编号",
                                                span: 8,
                                                disabled:true,
                                                prop: "contractCode",
                                                searchPlaceholder:"请输入 合同编号",
                                                
                                        },
                                        {
                                                label: "总分",
                                                span: 8,
                                                disabled:true,
                                                prop: "totalScore",
                                                searchPlaceholder:"请输入 合同编号",
                                                
                                        },
                                        {
                                                label: "基准分",
                                                span: 8,
                                                disabled:true,
                                                prop: "baseScore",
                                                searchPlaceholder:"请输入 合同编号",
                                                
                                        },
                                        {
                                                label: "备注",
                                                span: 24,
                                                type:"textarea",
                                                prop: "description",
                                                showWordLimit:true,
                                                maxlength:200,
                                                searchPlaceholder:"请输入 备注",
                                                
                                        },
                                        {
                                                label: "考核项目",
                                                span: 24,
                                                prop: "assessStandardDetailList",
                                                formslot:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请添加 考核项目",
                                                        trigger: "change"
                                                }]
                                                
                                        },
                                ]
                                
                        }
                }
        },
        methods:{
                // 新增考核项目
                rowSave(row) {
                        this.form.totalScore =  Number(this.form.totalScore) +  Number(row.score);
                        this.form.baseScore = Number(this.form.baseScore) +  Number(row.baseScore);
                        this.assessStandardDetailList.push(row);
                        this.$message.success('操作成功!');
                       
                },
                // 编辑考核项目
                rowUpdate(row) {
                        this.assessStandardDetailList.splice(row.$index,1,row);
                        let totalScore = 0;
                        let baseScore = 0;
                        this.assessStandardDetailList.forEach(ele=>{
                                totalScore += Number(ele.score);
                                baseScore += Number(ele.baseScore);
                        })
                        this.form.totalScore =  totalScore;
                        this.form.baseScore = baseScore;
                        this.$message.success('操作成功!');
                        
                },
                // 删除考核项目
                rowDel(row){
                        this.$confirm("此操作将删除该考核项目，是否继续?", {
                                confirmButtonText: "确定",
                                cancelButtonText: "取消",
                                type: "warning"
                        })
                        .then(() => {
                                this.form.totalScore -=  row.score;
                                this.form.baseScore -=  row.baseScore;
                                this.assessStandardDetailList.splice(row.$index,1);
                                return true;
                        })
                        .then(() => {
                                this.$message.success('操作成功!');
                        })
                        
                },
                //打开 编辑 弹窗
                handleEdit(row){
                        this.$refs.assessmentProjectForm.openDialog('edit',row)
                },
                // 新增或者提交 看有没有id
                submitAssess(){
                        if(this.assessStandardDetailList.length>0){
                                this.form.assessStandardDetailList = this.assessStandardDetailList;
                        }else{
                                this.form.assessStandardDetailList = [];
                        }
                        this.$refs.form.validate((valid)=>{
                                if(valid){
                                        this.loading = true;
                                        this.form.assessStandardDetailList = this.assessStandardDetailList;
                                        this.form.assessStandardDetailList.forEach((ele,index)=>{
                                                ele.sortNum = index + 1;
                                        })
                                        submitAssess(this.form).then(res=>{
                                                this.loading = false;
                                                this.$message({
                                                        message: '操作成功！',
                                                        type: 'success'
                                                });
                                                this.dialogVisible = false;
                                                this.$emit('onLoad')

                                        }).catch(()=>{
                                                this.loading = false;
                                        })
                                }
                        })
                },
                // 获取合同
                getContract(contract){
                        
                        this.form.contractId = contract.id;
                        this.form.contractName = contract.name;
                        this.form.contractCode = contract.code;
                },
                // 打开添加合同弹窗
                addConstract(){
                        this.$refs.choiceContract.openDialog();
                },
                // 新增一个考核项目
                handleAddObject(){
                        console.log(this.$refs.addObjectForm)
                        this.$refs.addObjectForm.validate((valid) => {
                                if (valid) {
                                        this.addObjectShow = false;
                                        this.addObject = [];
                                        this.form.totalScore =  Number(this.form.totalScore) +  Number(this.addObjectForm.score);
                                        this.form.baseScore = Number(this.form.baseScore) +  Number(this.addObjectForm.baseScore);
                                        this.assessStandardDetailList.push(this.addObjectForm);

                                } else {
                                        console.log('error submit!!');
                                        return false;
                                }
                        });
                },
                // 删除考核项目
                handleDeleteAssessStandardDetailList(scope,row){
                        console.log(scope)
                        this.form.totalScore -=  row.score;
                        this.form.baseScore -=  row.baseScore;
                        this.assessStandardDetailList.splice(scope.index,1);
                },
                // 删除新增临时表格中的数据
                handleDeleteObject(){
                        this.addObjectShow = false;
                        this.addObject = [];
                },
                // 新增考核项目
                addAssessStandard(){
                        if(this.addObject.length<1){
                                this.addObjectForm = {};
                                this.addObjectShow = true;
                                this.addObject.push({
                                        index:this.assessStandardDetailList.length+1
                                });

                        }
                        
                },
                headerClassBack(){
                        return 'avue-crud'
                },
              
                openDialog(type,data){
                        this.loading = true;
                        this.form = {
                                totalScore:0,
                                baseScore:0,
                        }
                        
                        // let assessStandardDetailOptionMenuColumn = this.findObject(this.assessStandardDetailOption.column,'menu');
                        if(type=='add'){
                                this.title = "新 增";
                                this.loading = false;
                                this.assessStandardDetailOption.menu = true;
                                // assessStandardDetailOptionMenuColumn.hide = false; 
                                this.viewType = false;
                                this.form.projectId = this.projectId;
                                this.initData();
                        }else if(type=='view'){
                                // assessStandardDetailOptionMenuColumn.hide = true; 
                                this.assessStandardDetailOption.menu = false;
                                this.title = "查 看";
                                this.viewType = true;
                                this.initData(data);
                               
                        }else if(type=='edit'){
                                this.viewType = false;
                                this.assessStandardDetailOption.menu = true;
                                 this.title = "编 辑";
                                this.initData(data);
                               
                                // assessStandardDetailOptionMenuColumn.hide = false; 
                               
                        }
                        this.dialogVisible = true;
                },
                async initData(data){
                        
                        this.assessStandardDetailList = [];
                        let temArr =  ['status','contractName','contractCode','baseScore',"totalScore"];
                        this.option.column.forEach((ele,index)=>{
                                
                                if(temArr.indexOf(ele.prop) == -1 && this.title=='查 看'){
                                        ele.disabled = true; 

                                }else if(temArr.indexOf(ele.prop) == -1 && this.title=='新 增'){
                                        ele.disabled = false;
                                }else if(temArr.indexOf(ele.prop) == -1 && this.title=='编 辑'){
                                                
                                        if(ele.prop=='projectId'||ele.prop=='objectType'){
                                                
                                                ele.disabled = true;
                                        }else{
                                                ele.disabled = false;
                                        }       
                                }
                                
                                
                        })
                        this.addObjectShow = false;
                        if(!data)return;
                        getDetail({id:data.id}).then(res=>{
                                this.form = res.data;
                                this.form.objectType = String(this.form.objectType);
                                this.assessStandardDetailList = res.data.assessStandardDetailList;
                                this.loading = false;
                        }).catch(()=>{
                                this.loading = false;
                        })
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        if(this.viewType){
                                self.dialogVisible = false;
                                return;
                        }
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                        self.dialogVisible = false;
                                if(done){
                                        // this.selectTimeFlag = false;

                                }else{
                                        // this.selectTimeFlag = false;
                                }
                                        // done();
                        })
                        .catch(()=> {
                                
                        });
                },
                dialogFullChange(){
                        let bodyHight = document.body.clientHeight;
                        this.dialogFull = !this.dialogFull;
                        if(this.dialogFull){
                                this.dialogBodyHight = bodyHight - 220;
                        }else{
                                this.dialogBodyHight = bodyHight - 320;
                        }
                },
        },
        mounted(){
                this.dialogFull = false;
                let bodyHight = document.body.clientHeight;

                this.dialogBodyHight = bodyHight - 320;

        },

}
</script>

<style lang="scss">
::v-deep .avue-crud .el-form-item {
  display: block;
}
#examinetopic-form .el-table .cell{
        white-space:inherit;
}
#examinetopic-form .avue-crud__pagination{
        padding: 0;
}
</style>